<template>
  <el-dialog
    v-model="formVisible"
    title="视频上传"
    @close="close"
    width="600px"
  >
    <div class="center">
      <div class="alter">
        提示：文件上传时刷新、关闭或离开全量解析，文件上传将终止。
      </div>
      <div class="alter">
        支持视频格式:.mp4,.ts,.ps,.mkv,.avi,.dat,.dav,.dh,.hk
      </div>
      <div class="alter warning">剩余存储容量906.00G</div>
      <el-form
        class="form"
        ref="formRef"
        :model="tableParams"
        :rules="rules"
        :disabled="status == 3"
        label-width="120px"
      >
        <el-form-item label="上传视频">
          <div class="form_upload">
            <el-upload
              action="#"
              ref="uploadRef"
              list-type="picture-card"
              :auto-upload="false"
              :on-change="uploadChange"
            >
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="文件名称" prop="file_name" style="width: 70%">
          <el-input
            v-model="tableParams.file_name"
            :disabled="false"
          ></el-input>
        </el-form-item>
        <el-form-item label="视频来源" prop="file_source">
          <!-- <el-select v-model="tableParams.value" placeholder="社会自建监控点">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select> -->
          <h-selectcode
            type="videosourceType"
            v-model="tableParams.file_source"
            placeholder="视频分组"
          ></h-selectcode>
        </el-form-item>
        <el-form-item label="视频分组" prop="group_id">
          <!-- <el-select v-model="tableParams.value" placeholder="默认分组">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select> -->
          <h-selectcode
            type="videoigroupType"
            v-model="tableParams.group_id"
            placeholder="视频分组"
          ></h-selectcode>
        </el-form-item>
        <el-form-item label="录像发生时间" class="timer">
          <el-date-picker
            v-model="tableParams.start_time"
            type="datetime"
            placeholder="请选择日期"
          />
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <h-button type="primary" @click="submit(formRef)">确定</h-button>
        <h-button type="denger" @click="close">取消</h-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  watchEffect,
  watch,
  ref,
  onMounted,
} from "vue";
import { authorization } from "@/api/videoAnalysis/videoAnalysisApi.js";
import SparkMD5 from "spark-md5";
import axios from "axios";
import request from "@/utils/request.js";
export default defineComponent({
  name: "uploading",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: 1,
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, context) {
    const state = reactive({
      formVisible: false,
      tableParams: {
        file_name: "",
        file_source: "1",
        group_id: "1",
        is_public: 1,
        latitude: "",
        location: "",
        longitude: 0,
        start_time: 0,
      },
      rules: {
        file_name: [
          {
            required: true,
            message: "请输入任务名称",
            trigger: "blur",
          },
        ],
        // file_source: [
        //   {
        //     required: true,
        //     message: "请选择资源",
        //     trigger: "blur",
        //   },
        // ],
        // group_id: [
        //   {
        //     required: true,
        //     message: "选择分组",
        //     trigger: "blur",
        //   },
        // ],
      },
      percent: 0,
      videoUrl: "",
      upload: true,
      percentCount: 0,
      //视频上传请求头
      headersInfo: {
        token: "",
        user: "",
      },
      fileInfoAxios: {},
      IP: window.huazhiIP,
      chunkSizeConfig: window.chunkSizeConfig,
      tabbleRowInfo: null,
      currentFile: null,
    });
    const formRef = ref(null);
    const uploadRef = ref(null);
    watchEffect(() => {
      state.formVisible = props.visible;
      nextTick(() => {
        initForm();
      });
    });
    const initForm = () => {
      if (props.status == 2 || props.status == 3) {
        state.tabbleRowInfo = props.info;
        state.tableParams.file_name = props.info.fileName;
        state.tableParams.file_source = props.info.fileSource;
        state.tableParams.group_id = props.info.groupId;
        state.tableParams.start_time = parseInt(props.info.createTime);
      }
    };
    const uploadChange = (file) => {
      state.currentFile = file;
      state.tableParams.file_name = file.name;
    };
    const handleChange = async (file) => {
      if (!file) return;
      state.percent = 0;
      state.videoUrl = "";
      // 获取文件并转成 ArrayBuffer 对象
      const fileObj = file.raw;
      let buffer;
      try {
        buffer = await fileToBuffer(fileObj);
      } catch (e) {
        console.log(e);
      }

      // 将文件按固定大小（2M）进行切片，注意此处同时声明了多个常量
      const chunkSize = state.chunkSizeConfig,
        chunkList = [], // 保存所有切片的数组
        chunkListLength = Math.ceil(fileObj.size / chunkSize), // 计算总共多个切片
        suffix = /\.([0-9A-z]+)$/.exec(fileObj.name)[1]; // 文件后缀名

      // 根据文件内容生成 hash 值
      const spark = new SparkMD5.ArrayBuffer();
      spark.append(buffer);
      const hash = spark.end();
      // 生成切片，这里后端要求传递的参数为字节数据块（chunk）和每个数据块的文件名（fileName）
      let curChunk = 0; // 切片时的初始位置
      for (let i = 0; i < chunkListLength; i++) {
        const item = {
          chunk: fileObj.slice(curChunk, curChunk + chunkSize),
          fileName: `${hash}_${i}.${suffix}`, // 文件名规则按照 hash_1.jpg 命名
        };
        curChunk += chunkSize;
        chunkList.push(item);
      }
      state.chunkList = chunkList; // sendRequest 要用到
      state.hash = hash; // sendRequest 要用到
      await getToken(fileObj);
    };
    //获取华智登录信息 并上传文件基本信息
    const getToken = async (fileObj) => {
      const res = await authorization();
      if (res.code == 0) {
        state.headersInfo = { ...state.headersInfo, ...res.data };
      }
      const form = {
        file_name: fileObj.name,
        file_size: fileObj.size,
        check_param: state.hash,
        describe: fileObj.name,
      };
      axios({
        url:
          state.IP +
          `/api/mg/v2/analysis-configuration/files?temp=${new Date().getTime()}`,
        method: "post",
        headers: {
          Authorization: state.headersInfo.token,
          user: state.headersInfo.user,
          "Content-Type": "application/json",
        },
        data: { ...form, ...state.tableParams },
      }).then((res) => {
        context.emit("updataTable");
        state.fileInfoAxios = { ...res.data };
        ElMessage.success("操作成功");
        // newRequest(fileObj.name, res.data.data.id);
        sendRequest(fileObj.name, res.data.data.id);
      });
    };
    // 文件上传( 测试单个小文件)
    const newRequest = (fileName, fileId) => {
      const formData = new FormData();
      formData.append("chunk", state.chunkList[0].chunk);
      formData.append("filename", state.chunkList[0].fileName);
      axios({
        url: state.IP + `/VIAS/Files/Upload`,
        method: "post",
        headers: {
          Authorization: state.headersInfo.token,
          User: state.headersInfo.user,
          "Session-ID": state.fileInfoAxios.data.file_id,
          "Content-Length": state.fileInfoAxios.data.file_size,
          "X-Content-Range": `bytes 0-${
            state.fileInfoAxios.data.file_size - 1
          }/${state.fileInfoAxios.data.file_size}`,
          // "X-Content-Range": `bytes 0-31457279/40262754`,
          "Content-Type": "application/octet-stream",
          "Storage-Info": state.fileInfoAxios.data.storage_info,
          "Content-Disposition":
            "attachment;filename=" + state.fileInfoAxios.file_name,
        },
        data: state.chunkList[0].chunk,
      }).then((res) => {
        changeFileStatus(fileName, fileId);
      });
    };
    // 文件上传状态修改
    const changeFileStatus = (fileName, id) => {
      axios({
        url:
          state.IP +
          `/api/mg/v2/analysis-configuration/files/update-upload-info/${id}`,
        method: "PUT",
        headers: {
          Authorization: state.headersInfo.token,
          User: state.headersInfo.user,
          "Content-Type": "application/json",
        },
        data: { file_name: fileName, upload_status: 3, upload_progress: 100 },
      }).then((res) => {
        console.log(res, "文件上传结束");
      });
    };
    // 文件上传 （大文件循环上传）
    const sendRequest = (fileName, fileId) => {
      const requestList = []; // 请求集合
      for (let index = 0; index < state.chunkList.length; index++) {
        let contentRange = 0;
        for (let num = 0; num <= index; num++) {
          contentRange += state.chunkList[num].chunk.size;
        }
        state.chunkList[index]["contentRange"] = contentRange;
      }
      state.chunkList.forEach((item, index) => {
        const fn = () => {
          return axios({
            url: state.IP + "/VIAS/Files/Upload",
            method: "post",
            headers: {
              Authorization: state.headersInfo.token,
              User: state.headersInfo.user,
              "Session-ID": state.fileInfoAxios.data.file_id,
              "Content-Length": state.fileInfoAxios.data.file_size,
              // "X-Content-Range": `bytes 0-${
              //   state.fileInfoAxios.data.file_size - 1
              // }/${state.fileInfoAxios.data.file_size}`,
              "X-Content-Range": `bytes ${
                index == 0 ? 0 : state.chunkList[index - 1].contentRange
              }-${item.contentRange - 1}/${state.fileInfoAxios.data.file_size}`,

              "Content-Type": "application/octet-stream",
              "Storage-Info": state.fileInfoAxios.data.storage_info,
              "Content-Disposition":
                "attachment;filename=" + state.fileInfoAxios.file_name,
            },
            data: item.chunk,
          }).then((res) => {
            if (res.status == 200 || res.status == 201) {
              // 成功
              if (state.percentCount === 0) {
                // 避免上传成功后会删除切片改变 chunkList 的长度影响到 percentCount 的值
                state.percentCount = 100 / state.chunkList.length;
              }
              state.percent += state.percentCount; // 改变进度
              // state.chunkList.splice(index, 1); // 一旦上传成功就删除这一个 chunk，方便断点续传
            }
          });
        };
        requestList.push(fn);
      });

      let i = 0; // 记录发送的请求个数
      //文件切片发送一个修改一次状态
      const complete = (progress) => {
        if (progress == 100) {
          setTimeout(() => {
            context.emit("updataTable");
          }, 60000);
        }
        return axios({
          url:
            state.IP +
            `/api/mg/v2/analysis-configuration/files/update-upload-info/${fileId}`,
          method: "PUT",
          headers: {
            Authorization: state.headersInfo.token,
            User: state.headersInfo.user,
            "Content-Type": "application/json",
          },
          data: {
            file_name: fileName,
            upload_status: progress == 100 ? 3 : 1,
            upload_progress: progress,
          },
        }).then((res) => {
          context.emit("updataTable");
        });
      };
      const send = async () => {
        if (i >= requestList.length) return; // 发送完毕
        await requestList[i]();
        await complete(state.percent);
        i++;
        send();
      };
      send(); // 发送请求
    };

    // 将 File 对象转为 ArrayBuffer
    const fileToBuffer = (file) => {
      return new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onload = (e) => {
          resolve(e.target.result);
        };
        fr.readAsArrayBuffer(file);
        fr.onerror = () => {
          reject(new Error("转换文件格式发生错误"));
        };
      });
    };
    // 添加
    const submit = async (formEl) => {
      if (!formEl) return;
      formEl.validate(async (valid) => {
        if (valid) {
          handleChange(state.currentFile);
          close();
        } else {
          return false;
        }
      });
    };
    //关闭弹窗
    const close = () => {
      context.emit("update:visible", false);
    };
    return {
      ...toRefs(state),
      formRef,
      uploadRef,
      submit,
      close,
      handleChange,
      uploadChange,
    };
  },
});
</script>

<style lang="scss" scoped>
.center {
  .alter {
    width: 80%;
    box-sizing: border-box;
    margin: 0 0 16px 50px;
    color: #333;
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: "tnum";
    position: relative;
    padding: 8px 15px 8px 37px;
    word-wrap: break-word;
    border-radius: 4px;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    margin-bottom: 16px;
    &.warning {
      color: red !important;
    }
  }
}
.form {
  // text-align: start;
  .el-form-item {
    width: 58%;
    .form_upload {
      display: flex;
      :deep(.el-upload--picture-card) {
        width: 100px;
        height: 100px;
      }
    }
    /deep/.el-upload-list--picture-card .el-upload-list__item {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
